import React from 'react';
import { Link } from 'react-router-dom';

export const NewsAdditions = ({ additions, products }) => {
  return (
    <section className="bg-[#FFF6F2] py-20 px-6 sm:px-48">
      {/* === Section Header === */}
      <div className="text-start mb-12">
        <h2 className="text-3xl sm:text-5xl font-semibold text-[#F8AF10] mb-2  just-me-again-down-here-regular">
          {additions?.label}
        </h2>
        <p className="text-gray-700 text-sm sm:text-lg">{additions?.caption}</p>
      </div>

      {/* === Image Grid === */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {products?.slice(0, 4).map((item, index) => (
          <Link
            to={`/products/${item.slug}`}
            key={index}
            className="flex flex-col items-center text-center group"
          >
            <div className="w-full overflow-hidden rounded-none shadow-md">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <p className="mt-4 text-sm sm:text-base font-medium text-gray-800">{item.title}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};
